import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { create } from "pinch-zoom-pan";

import css from "./pinchZoomPan.css";

export default function PinchZoomPan({
  min,
  max,
  captureWheel,
  className,
  style,
  children,
}) {
  const root = useRef();

  useEffect(() => {
    const element = root.current;
    console.log(element);
    if (!element) return;
    const canvas = create({
      element,
      minZoom: min,
      maxZoom: max,
      captureWheel,
    });
    canvas.update({ x: 0, y: 0, z: 1 });
    return canvas.destroy;
  }, [min, max, captureWheel]);

  return (
    <div ref={root} className={classNames(className, css.root)} style={style}>
      <div className={css.point}>
        <div className={css.canvas}>{children}</div>
      </div>
    </div>
  );
}
